(function () {
  'use strict';

  angular
    .module('directive.owl-carousel', [])

    /* @ngInject */
    .directive('owlCarousel', function () {

      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var thisScope = scope;
          var options = angular.extend({}, {
            nav: true,
            navText: ['‹', '›'],
            dots: true,
            lazyLoad: true,
            autoplayTimeout: 4000,
            loop: false,
            rewind: true,
            onInitialize: function (event) {
              $(event.target).closest('.tab-pane').addClass('in');
            },
            onInitialized: function (event) {
              thisScope.$apply(function () {
                thisScope.owlLoaded = true;
              });
              var $tab = $(event.target).closest('.tab-pane');
              if ($(event.target).hasClass('auto-height')) {
                $tab.height($tab.height());
              }
              $tab.removeClass('in');
            },
            onRefreshed: angular.isDefined(attrs.resize) ? eval(attrs.resize) : null,
            onResized: function (event) {
              for (var i in this._items) {
                if (this._items.hasOwnProperty(i)) {
                  var n = Number(i) + event.page.index;
                  if (n < event.page.size) {
                    this._plugins.lazy.load(i);
                  }
                }
              }
              var $tab = $(event.target).closest('.tab-content').children('.tab-pane');
              if ($(event.target).hasClass('auto-height')) {
                $tab.css({ 'height': '' });
              }
              $tab.removeClass('in');
            },
            onLoadLazy: function (event) {
              var lazyId = event.element.attr('lazy-id');
              thisScope.$apply(function () {
                thisScope['showLoader' + lazyId] = true;
              });
            },
            onLoadedLazy: function (event) {
              var $elem = event.element,
                lazyId = $elem.attr('lazy-id');
              $elem.addClass('loaded');
              thisScope.$apply(function () {
                thisScope['showLoader' + lazyId] = false;
              });
            }
          }, scope.$eval(attrs.owlCarousel));
          element.data('scope', scope);

          if (angular.isDefined(attrs.owlCarouselResponsive)) {
            scope.$on('imageLoaded', function () {
              setTimeout(function () {
                element.owlCarousel(options);
              });
            });
          } else {
            setTimeout(function () {
              element.owlCarousel(options);
            });
          }

          scope.$on('$destroy', function () {
            element.trigger('destroy.owl.carousel');
            element.removeData('scope');
          });
        }
      };
    });

})();


/* Resize functions */

// eslint-disable-next-line
function resizeProductGallery(event) {
  var $element = $(event.target),
    size = $(document.body).data('size');

  $element.toggleClass('active', event.active);

  if (event.active && $element.data('size') !== size) {
    $element.data('size', size);
    setTimeout(function () {
      var owl = $element.data('owl.carousel');
      owl._width = 0;
      owl.onResize();
    }, 0);
  }
  $element.addClass('owl-init');
}

// eslint-disable-next-line
function resizeProductsCarousels(event) {
  var $element = $(event.target);

  var i,
    $targ = $element.find('.content');
  $targ.children().removeAttr('style');
  var n = $targ.eq(0).children().length;
  for (i = 0; i < n; i++) {
    $targ.find('.' + $($targ.eq(0).children().eq(i)).attr('class').split(' ')[0]).equalHeights();
  }
  $element.addClass('owl-init');
}
